import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const spinnerVariants = cva(
  "animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
  {
    variants: {
      size: {
        default: "h-8 w-8",
        sm: "h-4 w-4",
        lg: "h-12 w-12",
        icon: "h-6 w-6",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

function Spinner({
  className,
  size,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof spinnerVariants>) {
  return (
    <div className={cn(spinnerVariants({ size, className }))} {...props} role="status" data-slot="spinner">
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !border-0 !p-0 !whitespace-nowrap ![clip:rect(0,0,0,0)]">
        Loading...
      </span>
    </div>
  );
}

export { Spinner };
